import { getLayoutData, getPageData } from "./api/api"
import ExtendedContent from "@/components/common/ExtendedContent"
import { FRAGMENTS } from "@repo/ui/lib"
import { DESIGN_FRAGMENTS } from "@/lib"
import dynamic from "next/dynamic"

const StickyHeading = dynamic(() => import("@repo/ui/src/components/StickyHeading"), {
	ssr: false,
})

export default function Home({ data, locale }) {
	const contentData = data?.content || []
	const stickyHeadingsSelectors = data?.stickyHeadingsSelector || []

	return (
		<>
			<StickyHeading stickyHeadingsSelectors={stickyHeadingsSelectors} isVisible />
			<ExtendedContent content={contentData} locale={locale} isSinglePage={true} hidePleoTags={true} />
		</>
	)
}

const SINGLE_PAGES_QUERY = `
	query GetHomePageData($locale: SiteLocale) {
		allDesignSinglePages(locale: $locale, filter: {slug: {eq: "home"}}) {
            singlePageName
            slug
			description
			${FRAGMENTS.SEO_META_FRAGMENT}
			${FRAGMENTS.THEME_FRAGMENT}
			${DESIGN_FRAGMENTS.STICKY_HEADING_FRAGMENT}
			content {
				__typename
				
				${FRAGMENTS.VIDEO_BANNER_FRAGMENT}
				${FRAGMENTS.DESCRIPTION_AND_SLOGAN_MODULE_FRAGMENT}
				${FRAGMENTS.HORIZONTAL_HEADER_MODULE_FRAGMENT}
				${FRAGMENTS.TEXT_MODULE_FRAGMENT}
                ${FRAGMENTS.WHO_WE_WORKED_WITH_MODULE_FRAGMENT}
                
				${DESIGN_FRAGMENTS.CHECK_OTHERS_FRAGMENT}
				${DESIGN_FRAGMENTS.SINGLE_ASSET_FRAGMENT}
                ${DESIGN_FRAGMENTS.SOCIAL_MEDIA_FRAGMENT}
		        ${DESIGN_FRAGMENTS.DESCRIPTION_LOGO_PLEO_FRAGMENT}
		        ${DESIGN_FRAGMENTS.BLOB_SLOGAN_FRAGMENT}
		        ${DESIGN_FRAGMENTS.FEATURED_PROJECTS_FRAGMENT}
		        ${DESIGN_FRAGMENTS.NEWS_THUMBNAILS_FRAGMENT}
		        ${DESIGN_FRAGMENTS.HOW_WE_CREATE_STORY_FRAGMENT}
			}
		}
	}
`

export async function getStaticProps(context) {
	const locale = context?.locale || "pl"
	const data = await getPageData("allDesignSinglePages", "home", SINGLE_PAGES_QUERY, locale)
	const { globals, cookies, footer, menu } = await getLayoutData(locale)

	return {
		props: {
			data,
			globals,
			cookies,
			locale,
			footer,
			menu,
		},
		revalidate: 120,
	}
}
